import React from 'react'
import { Link, useLocation } from 'react-router-dom';
import Footer from '../pages/Contact/Footer';




function Layout ({children}) {


  const location = useLocation()

  const menuItems = [
  {
    title : "Home",
    path : "/",
    icon : "ri-home-smile-line",
  },

  {
    title : "Über Uns",
    path : "/ueber_uns",
    icon : "ri-information-2-line",
  },

  {
    title : "Projekte ",
    path : "/projekte",
    icon : "ri-user-settings-fill",
  },

  {
    title : "Kontakt",
    path : "/kontakte",
    icon : "ri-contacts-fill",
  }
]
  return (
    /* 1. Conteneur principal en Flexbox colonne pour pousser le footer en bas */
    <div className="flex flex-col min-h-screen">
      
      {/* 2. Zone de contenu qui grandit pour occuper l'espace (flex-grow) */}
      <div className="flex-grow overflow-x-hidden pb-44 sm:pb-20">
        {children}
      </div>

      {/* 3. Le Footer s'affichera désormais sur TOUTES les pages ici */}
      <Footer />

      {/* 4. Barre de navigation fixe */}
      <div className='fixed bottom-10 left-0 right-0 sm:bottom-0 z-50'>
        <div className='flex w-full justify-center'>
          {menuItems.map((item, index) => (
            <div key={item.path} className='flex flex-col justify-end items-center w-full sm:w-auto'>
              
              {/* Indicateur visuel actif (Desktop) */}
              {location.pathname === item.path && (
                <div className='flex flex-col items-center hidden sm:flex'>
                  <div className='h-5 w-10 bg-primary rounded-t-full'></div>
                  <div className='h-5 w-20 bg-primary rounded-t-full text-center'>
                    <i className={`${item.icon} text-xl text-white`}></i>
                  </div>
                </div>
              )}

              <div className={`bg-primary px-3 sm:px-6 md:px-10 py-4 sm:py-5 ${
                index === 0 ? "rounded-none sm:rounded-l-lg" :
                index === menuItems.length - 1 ? "rounded-none sm:rounded-r-lg" : ""
              } flex items-center justify-center space-x-0 sm:space-x-2 min-w-max w-full sm:min-w-max flex-1 sm:flex-initial`}>

                <Link
                  to={`${item.path}`}
                  className="flex items-center justify-center space-x-0 sm:space-x-2 transition-transform duration-200 active:scale-95 origin-center"
                >
                  {/* Icône pour les pages non-actives */}
                  {location.pathname !== item.path && (
                    <i className={`${item.icon} text-secondary sm:text-xm`}></i>
                  )}

                  {/* Icône pour la page active (Mobile uniquement) */}
                  {location.pathname === item.path && (
                    <i className={`${item.icon} text-secondary text-lg sm:text-xm sm:hidden`}></i>
                  )}

                  {/* Titre (Visible uniquement sur Desktop) */}
                  <span className="text-secondary text-xm whitespace-nowrap hidden sm:inline">
                    {item.title}
                  </span>
                </Link>

              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Layout